import { USIO_EMAIL, USIO_PHONE } from '@bybeam/platform-types';
import ContactInfo, { contactInfoMarkdown } from '../ContactInfo/index.js';
import { Variant } from '../Typography/index.js';

interface UsioContactProps {
  variant?: Variant;
}

export default function UsioContact({ variant = 'body' }: UsioContactProps) {
  return <ContactInfo email={USIO_EMAIL} phone={USIO_PHONE} variant={variant} />;
}

export const usioContactMarkdown = contactInfoMarkdown({ email: USIO_EMAIL, phone: USIO_PHONE });
